import { MutationCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import { auditLogKeys } from '@/features/auditLog/audit-log-hooks.ts';

declare module '@tanstack/react-query' {
  interface Register {
    mutationMeta: {
      invalidatesAuditLog?: boolean;
    };
  }
}

export function getContext() {
  const queryClient = new QueryClient({
    mutationCache: new MutationCache({
      onSuccess: (data, _variables, _context, mutation) => {
        if (!mutation.meta?.invalidatesAuditLog) return;

        const entityId = (data as { id?: number | string })?.id;
        if (entityId == null) return;

        void queryClient.invalidateQueries({
          queryKey: auditLogKeys.byEntity(String(entityId)),
        });
      },
    }),
  });
  return {
    queryClient,
  };
}

export function Provider({
  children,
  queryClient,
}: {
  children: React.ReactNode;
  queryClient: QueryClient;
}) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
